module.exports = __webpack_public_path__ + "img/logo-menu.fa015ac0.svg";